import type { FunctionComponent } from "react";

import Button from "~/components/buttons/Button/Button";
import CardContent from "~/components/Card/components/CardContent";
import CardHeader from "~/components/Card/components/CardHeader";
import CardTitle from "~/components/Card/components/CardTitle";
import CardWrapper from "~/components/Card/components/CardWrapper";
import DetailsListItem from "~/components/DetailsList/components/DetailsListItem";
import { EMPTY_VALUE_PLACEHOLDER } from "~/constants/textConstants.ts";
import { invoiceTypeId } from "~/modules/billing/api/invoiceType.ts";
import type { Invoice } from "~/modules/billing/api/processedInvoice/processedInvoiceTypes.ts";
import { formatDateWithGermanMonth } from "~/utils/dateAndTimeUtils.ts";

type Props = { invoiceData: Invoice, onUpdateClick?: () => void };

const InvoicePaymentSection: FunctionComponent<Props> = ({ invoiceData, onUpdateClick }) => {
	const isSelfBilledInvoice = invoiceData.invoiceTypeId === invoiceTypeId.SelfBilledInvoice;
	const isOverdue = invoiceData.paymentDueAt && invoiceData.invoicePaidAt === null ? new Date(invoiceData.paymentDueAt) < new Date() : false;
	const deliveryDate = isSelfBilledInvoice ? invoiceData.invoiceReceivedAt : invoiceData.invoiceSentAt;
	const isSentToClient = invoiceData.invoiceSentAt !== null;
	return <CardWrapper hasTitle={true}
						padding="none">
		<CardHeader hasTitle={true}>
			<CardTitle>Zahlungsdetails</CardTitle>
			{onUpdateClick && <Button size="auto"
									  theme="plain"
									  className="px-2 py-1 text-xs"
									  onClick={onUpdateClick}>Bearbeiten</Button>}
		</CardHeader>
		<CardContent padding="none">
			<div className="grid grid-cols-[auto_1fr] gap-x-4 gap-y-2 px-4 py-3">
				<DetailsListItem label={isSelfBilledInvoice ? "Eingegangen am" : "Versendet am"}>
					{deliveryDate ? formatDateWithGermanMonth(new Date(deliveryDate)) : EMPTY_VALUE_PLACEHOLDER}
				</DetailsListItem>
				<DetailsListItem label="Zahlungsziel">
					{invoiceData.paymentTargetDays && (
						<span className={isOverdue ? "font-bold text-secondary-700" : ""}>
						{invoiceData.paymentTargetDays} Tage {invoiceData.paymentDueAt ? `(${formatDateWithGermanMonth(new Date(invoiceData.paymentDueAt))})` : ""}
					</span>)}
					{invoiceData.paymentTargetDays === null && EMPTY_VALUE_PLACEHOLDER}
				</DetailsListItem>
				<DetailsListItem label="Zahlungseingang">
					{isSentToClient && isOverdue && <span className="font-bold text-secondary-700">Überfällig</span>}
					{isSentToClient && !isOverdue && invoiceData.invoicePaidAt && formatDateWithGermanMonth(new Date(invoiceData.invoicePaidAt))}
					{isSentToClient && !isOverdue && !invoiceData.invoicePaidAt && "Ausstehend"}
					{!isSentToClient && EMPTY_VALUE_PLACEHOLDER}
				</DetailsListItem>
			</div>
		</CardContent>
	</CardWrapper>;
};

export default InvoicePaymentSection;